<template>
    <router-link to="/" @click.native="$scrollToTop">
        <div class="logo-container">
            <div class="logo">
                <img itemprop="logo" src="//cdn.sfdermato.org/img/logo/sfdermato.svg">
            </div>
            <div class="headline">
                <h1><span>Chrono<span>reco</span></span>L’app des dermatos</h1>
            </div>
        </div>
    </router-link>
</template>

<script>

export default {
  name: 'logo',
}
</script>

<style lang="scss">

    a {
        text-decoration: none;
    }

.logo-container {
    display: flex;
    align-items: center;
    position: relative;

    @include mq($until: SM) {
        padding-right: rem(5px);

        &::after {
            content: '';
            position: absolute;
            height: 100%;
            background: color(border);
            right: 0;
            width: 1px;
            top: 0;
        }
    }

    .logo {
        padding: rem(10px) rem(15px) rem(5px) 0;
        position: relative;

        img {
            min-width: rem(208px);
            max-width: rem(208px);
            min-height: rem(60px);

            @include mq($until: SM) {
                min-width: rem(140px);
                min-height: rem(36px);
                margin-left: rem(10px);
            }

            @include mq($from: SM, $until: LG) {
                min-width: rem(160px);
                min-height: rem(50px);
            }
        }

        &::after {
            content: '';
            position: absolute;
            height: 100%;
            background: color(border);
            right: 0;
            width: 1px;
            top: 0;
        }

        @include mq($until: MD) {
            padding: rem(8px) rem(5px) rem(4px) 0;
            margin-left: rem(-8px);
        }
    }

    .headline h1 {

        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding-left: rem(15px);
        line-height: rem(24px);
        color:color(sfdgreen);
        font-size: rem(14px);
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;

        @include mq($until: MD) {
            font-size: rem(8px);
            line-height: rem(14px);
            padding-left: rem(10px);
        }

        @include mq($from: MD, $until: LG) {
            font-size: rem(12px);
            line-height: rem(18px);
        }

        &::before {
            content: '';
            position: absolute;
            height: 100%;
            background: color(more);
            left: 0;
            width: 3px;
        }

        span {
	        color:color(more);
            font-size: rem(20px);

            span{color:color(skin)}

            @include mq($until: MD) {
                font-size: rem(12px);
            }

            @include mq($from: MD, $until: LG) {
                font-size: rem(18px);
            }
        }
    }
}

</style>
